import { config } from "../services/runtimeConfig";

/**
 * Same B2C tenant/app registration as the consumer web app (see
 * .env.example) -- admin access is authorized by B2C group membership
 * (ADMIN_GROUP_ID, checked server-side in api/services/auth.py's _is_admin),
 * not a separate policy. Sign-in with an account that isn't in the admin
 * group still succeeds against B2C; every API call then 403s, which
 * AuthContext surfaces as "not an admin" rather than a login failure.
 */
export const msalConfig = {
  auth: {
    clientId: config.b2cClientId,
    authority: config.b2cAuthority,
    knownAuthorities: [config.b2cKnownAuthority],
    redirectUri: config.b2cRedirectUri,
    postLogoutRedirectUri: config.b2cRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const mfaStepUpAuthority = config.b2cMfaAuthority;

export const loginRequest = {
  scopes: [`${config.b2cClientId}/.default`],
};
